import moment from 'moment'
import angular from "angular";

const CHARGECODE_ID_LWOP = 1011

class AutoLwopService {
  constructor(LeaveService, AuthenticationService) {
    "ngInject"

    this.ptoService = LeaveService
    this.authenticationService = AuthenticationService
    this.leaveTracker = {}

    this.resetState()

  }

  resetState() {
    this.state = {
      leaveHoursUntilLWOP: 0,
      isLwop: false,
      threshold: null,
      disabled: false,
    }
    this.leaveTracker = {}
  }

  disable() {
    this.state.disabled = true
  }

  /**
   * Creates an initial leave tracking map for all dates of the timesheet.
   *
   * @param {*} timesheet
   */
  sync(timesheet) {
    if (this.state.disabled) {
      return
    }

    if (!timesheet || !this.ptoService.leaveTypes) return

    // NOTE: This assumes PTO is the default leave type for users
    // console.log('leaveTypes', this.ptoService.leaveTypes)
    const ptoLeaveType = this.ptoService.leaveTypes.find(leaveType => leaveType.leaveTypeName === 'PTO')
    if (!ptoLeaveType) {
      console.warn('PTO Leave type not found!')
      return
    }


    const currYear = parseInt(moment().year())
    const currentPtoLeaveStats = this.ptoService.calculateLeaveTypePtoStats(ptoLeaveType, currYear)
    // console.log('currentPtoLeaveStats', currentPtoLeaveStats)

    // Positive value for threshold - the amount of hours allowed to go under balance
    const threshold = -ptoLeaveType.negativeThreshold

    const leaveBalance = parseFloat(currentPtoLeaveStats.balance)
    const leaveBalanceBeforeTimesheet = leaveBalance + timesheet.info.leaveHours

    // Hours left before going into LWOP
    let leaveHoursUntilLwop = leaveBalanceBeforeTimesheet + threshold

    // leaveTracker keeps track of lwop status on a daily basis since we can go in and out of
    // lwop during a timesheet period
    this.leaveTracker = {}

    // First, create leave tracker entries with leave hours from timesheet
    timesheet.timeEntries.forEach((timeEntry) => {
      if (timeEntry.chargeCode.leaveType) {
        // Create a new date entry if it doesn't already exist
        if (!this.leaveTracker[timeEntry.date]) {
          this.leaveTracker[timeEntry.date] = {
            leaveHours: [],
            hoursUntilLwop: null,
            isLwop: false,
          }
        }

        this.leaveTracker[timeEntry.date].leaveHours.push({
          chargeCodeId: timeEntry.chargeCode.id,
          chargeCodeName: timeEntry.chargeCode.name,
          hours: timeEntry.hours,
        })
      }
    })

    // Then iterate through leaveTracker and set lwop related values
    const dates = Object.keys(this.leaveTracker)
    dates.forEach((date) => {
      const entry = this.leaveTracker[date]

      const totalLeaveHrs = entry.leaveHours.reduce((sum, leaveHours) => sum + (leaveHours.hours || 0), 0)
      // console.log('totalLeaveHrs', totalLeaveHrs)

      leaveHoursUntilLwop -= totalLeaveHrs

      entry.hoursUntilLwop = leaveHoursUntilLwop
      entry.isLwop = leaveHoursUntilLwop <= 0
    })

    // Set overall lwop status properties
    this.state.leaveHoursUntilLWOP = leaveHoursUntilLwop
    this.state.isLwop = leaveHoursUntilLwop < 0
    this.state.threshold = threshold

    console.log('++++++ leaveTracker', this.leaveTracker)
  }
}

let autoLwopModule = angular.module('autoLwop', []).service('AutoLwopService', AutoLwopService)

export default autoLwopModule



// WEBPACK FOOTER //
// ./client/pages/timesheet/services/auto-lwop.service.js